import { useState } from 'react'

import { StaticLinkFormModel } from '../staticLinkForm/StaticLinkForm.types'

import { Loader } from '@percent/lemonade'
import { useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation, useQuery } from '@percent/utility'
import { EditStaticLink } from './EditStaticLink'

export function EditStaticLinkContainer() {
  const { id: partnerId, staticLinkId } = useRequiredParams<{ id: string; staticLinkId: string }>()
  const { validationSubmissionsService, adminService } = useServices()
  const [slugConfigModalStatus, setSlugConfigModalStatus] = useState<'success' | 'error' | null>(null)

  const { data: configurations, isLoading: isLoadingConfigurations } = useQuery(
    ['validation-submission-configurations', partnerId],
    validationSubmissionsService.getValidationSubmissionConfigurations,
    { partnerId, pageSize: 100 }
  )

  const { data: staticLinks, isLoading: isLoadingStaticLinks } = useQuery(
    ['static-links', partnerId],
    adminService.queries.getStaticLinks,
    { partnerId }
  )

  const staticLink = staticLinks?.find(sl => sl.id === staticLinkId)

  const [{ isPending: isSaving }, { mutateAsync: updateStaticLink }] = useMutation(
    adminService.commands.updateStaticLink,
    () => setSlugConfigModalStatus('success'),
    () => setSlugConfigModalStatus('error')
  )

  const handleSubmit = async (values: StaticLinkFormModel) => {
    setSlugConfigModalStatus(null)

    try {
      await updateStaticLink({
        id: staticLinkId,
        payload: {
          slug: values.slug,
          validationSubmissionConfigurationId: values.validationSubmissionConfigurationId,
          redirectUrl: values.redirectUrl || null,
          isEnabled: values.isEnabled,
          enablePost: values.enablePost,
          allowedOrigin: values.enablePost && values.allowedOrigin ? values.allowedOrigin : null
        }
      })
    } catch {
      // Error is handled by useMutation's onError callback
    }
  }

  if (isLoadingStaticLinks || !staticLink) {
    return <Loader />
  }

  return (
    <EditStaticLink
      configurations={configurations ?? []}
      isLoadingConfigurations={isLoadingConfigurations}
      onSubmit={handleSubmit}
      isSaving={isSaving}
      slugConfigModalStatus={slugConfigModalStatus}
      setSlugConfigModalStatus={setSlugConfigModalStatus}
      staticLink={staticLink}
    />
  )
}
